import { render } from "./transfer.vue?vue&type=template&id=a1560fc6&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"

import "./transfer.vue?vue&type=style&index=0&id=a1560fc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1560fc6"]])

export default __exports__